"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Subscription", {
  enumerable: true,
  get: function get() {
    return _Subscription.Subscription;
  }
});
var _Subscription = require("./Subscription");